export default __webpack_public_path__ + "assets/images/mastercard-white.969c8ed56d3ee753274bd110dcf447e5.svg";